const HowItWorksStep = () => (
  <div className='flex flex-col items-start justify-center h-full gap-8 px-10 mb-40'>
    <div className='space-y-4'>
      <span className='text-main font-bold block text-[18px]'>How it works</span>
      <span className='text-main block text-base'>Here&apos;s how the process works and what you need to know.</span>
    </div>

    <div className='flex flex-col items-start gap-6 text-base'>
      <div className='flex flex-col items-start gap-2'>
        <span className='text-main font-bold'>📤 Upload your lease</span>
        <span className='text-main'>
          Upload your lease so we can verify your rental address for credit reporting.
        </span>
      </div>

      <div className='flex flex-col items-start gap-2'>
        <span className='text-main font-bold'>🚫 No landlord contact needed</span>
        <span className='text-main'>We do not need to contact your landlord or property manager.</span>
      </div>
      <div className='flex flex-col items-start gap-2'>
        <span className='text-main font-bold'>⚠️ Cancel with caution</span>
        <span className='text-main'>
          If you cancel Credit Builder, you won&apos;t be able to reactivate it at the same address.
        </span>
      </div>
    </div>
  </div>
);

export default HowItWorksStep;
